import React, { FC, useContext } from 'react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import { Link } from '../../Link/Link'
import { getLkUrl } from '../../../utils/url'
import { CheckBox } from './CheckBox/CheckBox'
import { LocaleContext } from '../../LocaleContext/LocaleContext'
import { useEnv } from '../../../utils/useEnv'
import { ROUTES } from '../../../routes/routes'
import { LanguageContext } from '../../LanguageContext/LanguageContext'
import { Languages } from '../../../interfaces/common'
import { UserAgreements } from '../../formComponents/UserAgreements/UserAgreements'
import style from '../../formComponents/UserAgreements/UserAgreements.module.css'
import { getQueryParam } from '../../../utils/getQueryParam'

const FIRST_TEXT = 'app.formComponents.form.submitButton.confirmation.firstText'
const SECOND_TEXT = 'app.formComponents.form.submitButton.confirmation.secondText'
const THIRD_TEXT = 'app.formComponents.form.submitButton.confirmation.thirdText'
const CONDITIONAL_TITLE = 'app.formComponents.form.submitButton.confirmation.conditionalTitle'
const PERSONAL_DATA_POLICY = 'app.formComponents.form.submitButton.confirmation.personalDataPolicy'
const CONDITIONAL_TITLE_UZ = 'app.formComponents.form.submitButton.confirmation.conditionalTitleUz'
const CONSENT_TO_PROCESSING = 'app.formComponents.form.submitButton.confirmation.consentToProcessing'
const CONSENT_TO_GETTING = 'app.formComponents.form.submitButton.confirmation.consentToGetting'
const UNIVERSITY_CONSENT_TO_PROCESSING =
  'app.formComponents.form.submitButton.confirmation.universityConsentToProcessing'
const TRANSFER_TO_THIRD_PARTIES = 'app.formComponents.form.submitButton.confirmation.transferToThirdParties'
const UNSUBSCRIBE_LABEL = 'app.formComponents.form.submitButton.confirmation.unsubscribe'

type UserAgreementsProps = {
  universityUserAgreements?: boolean
}

export const RegistrationFormUserAgreements: FC<UserAgreementsProps> = ({ universityUserAgreements }) => {
  const t = useTranslations()
  const { locale } = useContext(LocaleContext)
  const { language } = useContext(LanguageContext)
  const { query } = useRouter()
  const form = getQueryParam(query, 'form')

  const deployEnv = useEnv()

  const firstText = t(FIRST_TEXT)
  const secondText = t(SECOND_TEXT)
  const thirdText = t(THIRD_TEXT)
  const conditionalTitle = t(CONDITIONAL_TITLE)
  const personalDataPolicy = t(PERSONAL_DATA_POLICY)
  const eulaHref = getLkUrl(`${ROUTES.AGREEMENT_TERMS_OF_USE_PAGE}?lang=${language}`, deployEnv, locale)
  const personalDataPolicyURL = getLkUrl(ROUTES.PERSONAL_DATA_POLICY, deployEnv, locale)
  const consentToProcessing = t(CONSENT_TO_PROCESSING)
  const consentToGetting = t(CONSENT_TO_GETTING)
  const processingPersonalDataHref = getLkUrl(ROUTES.AGREEMENT_DATA_PROCESSING_PAGE, deployEnv, locale as Languages)
  const receiveAdvertisingMailingsHref = getLkUrl(ROUTES.AGREEMENT_MAILINGS_PAGE, deployEnv, locale as Languages)
  const universityConsentToProcessing = t(UNIVERSITY_CONSENT_TO_PROCESSING)
  const agreementStudentsDataHref = getLkUrl(ROUTES.AGREEMENT_STUDENTS, deployEnv, locale as Languages)
  const transferToThirdParties = t(TRANSFER_TO_THIRD_PARTIES)
  const newForm = form === '15'
  const unsubscribeLabel = t(UNSUBSCRIBE_LABEL)

  return (
    <UserAgreements>
      <>
        {locale === Languages.KZ && (
          <>
            {firstText}{' '}
            <Link className={style.userAgreementsLink} isExternal href={eulaHref}>
              {conditionalTitle}
            </Link>
          </>
        )}
        {language === Languages.RU && locale === Languages.RU && (
          <>
            {firstText}{' '}
            <Link className={style.userAgreementsLink} isExternal href={personalDataPolicyURL}>
              {personalDataPolicy}
            </Link>
          </>
        )}
        {language !== Languages.UZ && locale === Languages.UZ && (
          <>
            {firstText}{' '}
            <Link className={style.userAgreementsLink} isExternal href={eulaHref}>
              {conditionalTitle}
            </Link>
          </>
        )}
        {language === Languages.UZ && (
          <div>
            {secondText}
            <Link className={style.userAgreementsLink} isExternal href={eulaHref}>
              {t(CONDITIONAL_TITLE_UZ)}
            </Link>
            {thirdText}
          </div>
        )}
        {language === Languages.RU && locale !== Languages.UZ && (
          <>
            {' '}
            {secondText}{' '}
            {universityUserAgreements && (
              <>
                <Link className={style.userAgreementsLink} isExternal href={processingPersonalDataHref}>
                  {universityConsentToProcessing}
                </Link>
              </>
            )}
            {!universityUserAgreements && (
              <>
                <Link className={style.userAgreementsLink} isExternal href={processingPersonalDataHref}>
                  {consentToProcessing}
                </Link>
              </>
            )}
            {universityUserAgreements && (
              <>
                ,{' '}
                <Link className={style.userAgreementsLink} isExternal href={agreementStudentsDataHref}>
                  {transferToThirdParties}
                </Link>
              </>
            )}{' '}
            {thirdText}{' '}
            <Link className={style.userAgreementsLink} isExternal href={receiveAdvertisingMailingsHref}>
              {consentToGetting}
            </Link>
            . {newForm && <CheckBox label={unsubscribeLabel} />}
          </>
        )}
      </>
    </UserAgreements>
  )
}
